import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import 'rxjs/add/operator/toPromise';
import { Subject } from 'rxjs/Rx'
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { AppraisalService } from '../services/appraisal.service';
import { LoginService } from '../services/login.service'
import {MatTableDataSource} from '@angular/material';

@Component({
  selector: 'app-self-appraisal-archieve',
  templateUrl: './self-appraisal-archieve.component.html',
  styleUrls: ['./self-appraisal-archieve.component.css']
})
export class SelfAppraisalArchieveComponent implements OnInit {
  appraisal_archieve;

  constructor( private apprais : AppraisalService,public ls : LoginService, private router : Router) {
    
      
          var prev_year = this.apprais.getSelfAppraisalArchieve().subscribe( res => {
            this.appraisal_archieve = res.appraisal_archieve;
            console.log(this.appraisal_archieve)
          })
    
       }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/self-appraisal-archieve/self-appraisal-archieve.component.ts